
import { Inject, Injectable, DOCUMENT } from '@angular/core';
import { ValidatedWhitelabelConfig } from './whitelabel-config.model';

@Injectable({ providedIn: 'root' })
export class RuntimeThemeService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  apply(config: ValidatedWhitelabelConfig): void {
    const root = this.document.documentElement;
    const tokens: Record<string, string> = {
      '--color-primary': config.colors.primary,
      '--color-on-primary': config.colors.primaryTextColor,
      '--color-secondary': config.colors.secondary,
      '--color-on-secondary': config.colors.secondaryButtonText,
      '--color-background': config.colors.bg,
      '--color-text': config.colors.font,
      '--color-heading': config.colors.heading,
      '--color-border': config.colors.border,
      '--color-border-light': config.colors.borderLight,
      '--color-nav': config.colors.nav,
      '--color-nav-text': config.colors.navLight,
      '--color-footer': config.colors.footerBg,
      '--color-footer-bg': config.colors.footerBg,
      '--font-body': `"${config.fonts.body}", sans-serif`,
      '--font-title': `"${config.fonts.title}", sans-serif`,
      '--font-body-weight': String(config.fonts.bodyWeight),
      '--font-title-weight': String(config.fonts.titleWeight)
    };
    Object.entries(tokens).forEach(([name, value]) => root.style.setProperty(name, value));

    if (config.self.favIcon) {
      let favicon = this.document.querySelector<HTMLLinkElement>('link[rel~="icon"]');
      if (!favicon) {
        favicon = this.document.createElement('link');
        favicon.rel = 'icon';
        this.document.head.appendChild(favicon);
      }
      favicon.href = config.self.favIcon;
    }

    if (config.fonts.useFonts) {
      const families = Array.from(new Set([config.fonts.body, config.fonts.title]));
      const fontLink = this.document.createElement('link');
      fontLink.rel = 'stylesheet';
      fontLink.setAttribute('data-whitelabel-fonts', 'true');
      fontLink.href = `https://fonts.googleapis.com/css2?${families
        .map(font => `family=${encodeURIComponent(font)}:wght@400;500;600;700;800`)
        .join('&')}&display=swap`;
      this.document.head.appendChild(fontLink);
    }
  }
}
